export default "__VITE_ASSET__cec63113__"